import { RouterGuard } from '../../services/router/types';

/**
 * Handle external routes.
 */
export const externalGuard: RouterGuard = function externalGuard(to, from, next) {
  // Immediately return if route is not external.
  if (to.meta.external) {
    if (to.meta.newWindow) {
      window.open(to.fullPath);
    }
    else {
      window.location.href = to.fullPath;
    }

    // Indicate that this guard handled the request and routing should stop.
    next(false);
  }
  else {
    next();
  }
};
